/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line  

  var lastScrollTop = 0;
  $(window).on('scroll', function() {
    st = $(this).scrollTop();
    if(st < lastScrollTop) {
      //console.log('up 1');
      $('.theme__header').addClass('up');
      $('.theme__header').removeClass('down');
    }
    else {
      console.log('down 1');
      $('.theme__header').addClass('down');
      $('.theme__header').removeClass('up');
    }
    lastScrollTop = st;
  });
  
  $( document ).ready(function() {
   var diff1 =$('.select-popout__list.option_size li a[aria-current="true"]').attr('data-diff');
   $('.select-popout__list.option_framing-options li a span.size_prize.last_prize').text("+ " + diff1);
  });
  
  $('.select-popout__list.option_size li a').on( "click", function() {
    var diff=$(this).attr('data-diff');
    $('.select-popout__list.option_framing-options li a span.size_prize.last_prize').text("+ " + diff);
  });

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
